import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { SearchRecord, SearchPackage } from '../../models/searchPackage';
import * as _ from 'lodash';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchManagementDialogComponent } from '../search-management-dialog/search-management-dialog.component';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.less']
})
export class SearchListComponent implements OnInit {

  @Input() public package: SearchPackage;
  @Input() public showActionButtons: boolean;
  
  @ViewChild('form', {}) ngForm: NgForm;
  
  public selectedSearch: SearchRecord;

  constructor(public auth: AuthService,
    public searches: SearchPackageService,
    public toast: ToastrService,
    private modalService: NgbModal) { }


    
    public get standardSearches() : Array<SearchRecord> {
      return this.package.searches;
    }

    

  ngOnInit() {
  }

  GetCreditRepositoryName(repo: number) {
    try {
      return this.searches.creditRepositories.find(r => { return r.id == repo }).name;
    } catch (error) {

    }
  }

  editSearch(srch: SearchRecord) {
    const modalRef = this.modalService.open(SearchManagementDialogComponent, { centered: true, size: 'lg' })
    modalRef.componentInstance.name = 'SearchManagementDialogComponent';
    modalRef.componentInstance.search = srch;
  }

  removeSearch(srch : SearchRecord){
    let pld = new ObjectUpdatePayload();
    pld.userId = this.auth.loggedInUser.id;
    pld.delete = true;
    pld.objectId = srch.id;

    this.searches.RemoveSearchFromPackage(srch.id,this.package.id).subscribe((scc: any)=>{
      if(scc){
        this.toast.success(`Search Removed Successfully`);
        this.package.searches.splice(this.package.searches.indexOf(srch),1);
      }
      else
        this.toast.error(`Error Removing Search : ${srch.name}`);
    
    },(err: any)=>{
      this.toast.error(`Error Removing Search : ${srch.name}`);
    })
  }

  getcountiesforState(state: string) {
    return this.searches.stateData.filter(sd => { return sd.stateAbbr == state }).map(s => { return s.countyName; });
  }

  getSearchesArray(): SearchRecord[] {
    return this.package.searches.filter(p => { return p.searchType != 9 }).sort((a, b) => {
      if (a.searchType < b.searchType) return -1;
      if (a.searchType > b.searchType) return 1;
      return 0;
    });
  }
}
